import api from './api';

class DivisionService {
  getDivisions() {
    return api.get('secure/team/divisions');
  }

  getDivisionsTeams(leagueId) {
    if (leagueId) {
      return api.get(`secure/team/teamsbydiv?leagueId=${leagueId}`);
    }
    return api.get('secure/team/teamsbydiv');
  }

}

export default new DivisionService();